var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4C4.44772 4 4 4.44771 4 5V9.54545C4 10.0977 4.44771 10.5455 5 10.5455H9.54545C10.0977 10.5455 10.5455 10.0977 10.5455 9.54545V5C10.5455 4.44772 10.0977 4 9.54545 4H5ZM14.8181 4.00007C14.2659 4.00007 13.8181 4.44778 13.8181 5.00007V9.54552C13.8181 10.0978 14.2659 10.5455 14.8181 10.5455H19.3636C19.9159 10.5455 20.3636 10.0978 20.3636 9.54552V5.00007C20.3636 4.44778 19.9159 4.00007 19.3636 4.00007H14.8181ZM13.8181 14.8182C13.8181 14.266 14.2659 13.8182 14.8181 13.8182H19.3636C19.9159 13.8182 20.3636 14.266 20.3636 14.8182V19.3637C20.3636 19.916 19.9159 20.3637 19.3636 20.3637H14.8181C14.2659 20.3637 13.8181 19.916 13.8181 19.3637V14.8182ZM4.99997 13.8182C4.44768 13.8182 3.99997 14.266 3.99997 14.8182V19.3637C3.99997 19.916 4.44768 20.3637 4.99997 20.3637H9.54542C10.0977 20.3637 10.5454 19.916 10.5454 19.3637V14.8182C10.5454 14.266 10.0977 13.8182 9.54542 13.8182H4.99997Z",
    fill: "#3A3C45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCards);
export default __webpack_public_path__ + "static/media/icon-cards.395c18bd.svg";
export { ForwardRef as ReactComponent };